<template lang="pug">
  div#html-dump
    slot
</template>

<script>
export default {
  name: 'HtmlDump'
}
</script>

<style scoped lang="stylus">
>>> video
>>> iframe
  width 100%
  height 100%

>>> img
  object-fit contain
  width 100%
  height 100%
</style>



// WEBPACK FOOTER //
// src/components/fragments/HtmlDump.vue